/* cacheThunk.ts */

/* Redux Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

export const flushRedisCache = createAsyncThunk(
  "flushCache",
  async () => {
    try {
      const response = await axiosInterceptor.get(
        "/redis/flush_cache"
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  }
);
